import { render } from "./BattlesSpinner.vue?vue&type=template&id=b009356a&scoped=true"
import script from "./BattlesSpinner.vue?vue&type=script&lang=js"
export * from "./BattlesSpinner.vue?vue&type=script&lang=js"

import "./BattlesSpinner.vue?vue&type=style&index=0&id=b009356a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b009356a"]])

export default __exports__